import React, { useState } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import instaIconRed from "../images/insta-red.png";
import instaIconLight from "../images/insta-white.png";
import { scrollToId } from "../functions/scroll";

const TopBar = ({ variant = "default" }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const handleLogoClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      history.push("/");
    }
  };

  const isWorkActive =
    location.pathname === "/" && location.hash === "#projects";

  const handleWorkClick = (e) => {
    e.preventDefault();

    if (location.pathname === "/") {
      history.push({
        pathname: "/",
        hash: "#projects",
      });
      scrollToId("#projects");
    } else {
      history.push("/", { scrollToProjects: true });
    }
  };

  const instaIcon = variant === "red" ? instaIconLight : instaIconRed;

  return (
    <div className={`top-bar top-bar--${variant}`}>
      <div className="container-max-width">
        <div className="page-logo">
          <Link to="/" className="logo-link" onClick={handleLogoClick}>
            <h2>Jade Law</h2>
          </Link>
        </div>

        <div className="top-menu desktop-menu">
          <button
            onClick={handleWorkClick}
            className={`button-unstyled nav-link ${
              isWorkActive ? "active" : ""
            }`}
          >
            Work
          </button>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            About
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Contact
          </NavLink>

          <a
            href="https://www.instagram.com/art.by.jade.law/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link icon-link"
          >
            <img src={instaIcon} alt="Instagram" className="insta-icon" />
          </a>
        </div>

        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* MOBILE MENU */}
      <div className={`top-menu mobile-menu ${menuOpen ? "open" : ""}`}>
        <button
          onClick={handleWorkClick}
          className={`button-unstyled nav-link ${isWorkActive ? "active" : ""}`}
        >
          Work
        </button>

        <NavLink to="/about" className="nav-link">
          About
        </NavLink>

        <NavLink to="/contact" className="nav-link">
          Contact
        </NavLink>

        <a
          href="https://www.instagram.com/art.by.jade.law/"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link icon-link"
        >
          {/* ALWAYS default icon */}
          <img src={instaIconRed} alt="Instagram" className="insta-icon" />
        </a>
      </div>
    </div>
  );
};

export default TopBar;
